import { VIANUVEM_API_ENDPOINT } from "./Defaults";
import AWS from 'aws-sdk';

const headers = {
    "content-type": "application/json"
}

export const getStorageLocal = (data) => {
    return new Promise((resolve, reject) => {
        fetch(`${VIANUVEM_API_ENDPOINT}/public/users/photo/${data.extension}/${data.token}`)
            .then(response => {
                if (+response.status !== 200) {
                    reject('Um problema ocorreu por favor contate o suporte.');
                }

                resolve(response.text());
            })
            .catch(reject)
    });
}

export const getSignedURL = storageLocal => {
    return new Promise((resolve, reject) => {
        fetch(`${VIANUVEM_API_ENDPOINT}/public/users/userCreate/photo/sign`,
            {
                method: 'PUT',
                body: JSON.stringify({ storageLocal }),
                headers
            })
            .then(response => {
                if (+response.status !== 200) {
                    reject('Um problema ocorreu por favor contate o suporte.');
                }

                resolve(response.json());
            })
            .catch(reject)
    });
}

export const uploadToS3 = ({file, path}) => {
    const bucketName = 'homolog-vianuvem';
    const bucketRegion = 'us-east-1';
    const IdentityPoolId = 'us-east-1:dcee2b25-c6e5-4a49-ada4-578aea59e10d';

    AWS.config.update({
        region: bucketRegion,
        credentials: new AWS.CognitoIdentityCredentials({
            IdentityPoolId: IdentityPoolId
        })
    });

    const s3 = new AWS.S3({
        apiVersion: '2006-03-01',
        endpoint: 'https://homolog-vianuvem.s3-accelerate.amazonaws.com',
        s3BucketEndpoint: true,
        params: {Bucket: bucketName}
    });

    return new Promise((resolve, reject) => {
        s3.upload({
            Key: path,
            Body: file,
            ContentType: file.type,
            StorageClass: 'STANDARD_IA'
        }, (err, data) => {
            if(err != null){
                reject(err);
            } else {
                resolve(path);
            }
        });
    });
};



// WEBPACK FOOTER //
// ./src/integrations/AvatarAPI.js